// Quais ações do atendimento ficam como botão na barra do cabeçalho.
//
// O menu ⋮ continua tendo TUDO: a barra é atalho, não é o catálogo. É por isso
// que esconder um botão nunca deixa a ação inalcançável — e é a regra que
// permite deixar a escolha na mão de quem usa.
//
// Resolver, Aceitar e Reabrir não entram: são a decisão do atendimento, e uma
// barra sem elas não seria uma barra.
export const ACOES_DA_BARRA = [
	{ id: "ligar", rotulo: "Ligar", dica: "Liga para o cliente pelo próprio sistema." },
	{ id: "notas", rotulo: "Notas internas", dica: "Anotações que só a equipe vê. O cliente não recebe." },
	{ id: "copiloto", rotulo: "Copiloto de IA", dica: "A IA lê a conversa e ajuda a responder." },
	{ id: "arquivos", rotulo: "Arquivos do atendimento", dica: "Todas as fotos e documentos desta conversa num lugar só." },
	{ id: "transferir", rotulo: "Transferir", dica: "Passa o atendimento para outro atendente ou departamento." },
	{ id: "robo", rotulo: "Pausar/reativar robô", dica: "Para o robô (fluxo e IA) de responder nesta conversa." },
	{ id: "automacao", rotulo: "Automação da conversa", dica: "Vê e muda se o robô responde aqui, e por quanto tempo fica pausado." },
	{ id: "kanban", rotulo: "Adicionar ao Kanban", dica: "Põe o cliente num quadro de etapas, como um funil de vendas." },
	{ id: "replay", rotulo: "Ver replay", dica: "Revê o atendimento passo a passo, mostrando onde demorou." },
];

export const IDS_ACOES_DA_BARRA = ACOES_DA_BARRA.map((a) => a.id);

// O padrão é o que a barra sempre teve — quem não mexer não vê diferença.
export const ACOES_PADRAO = ["ligar", "notas", "copiloto", "arquivos"];
